import { forwardRef, useEffect } from "react";
import {
  Grid,
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Divider,
  ListItemText,
  List,
  ListItem,
  Typography,
  ListSubheader,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  ListItemIcon,
  MenuItem,
  Select,
  Tabs,
  Tab,
  Slide,
  FormControl,
  InputLabel,
  Avatar,
  Menu,
  InputAdornment,
  ListItemButton,
  alertTitleClasses,
} from "@mui/material";
import BottomMenu from "./BottomMenu";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import { Fragment, useState } from "react";
import axios from "axios";
import DialogText from "./DialogText";
import add_comma from "../lib/add_comma";
import pr from "../lib/pr";
import moment from "moment";
import Swal from "sweetalert2";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { loginState, configState } from "../lib/State";
import send_webview_data from "../lib/send_webview_data";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, StaticDatePicker, TabContext } from "@mui/lab";
import { useParams } from "react-router";
import { TabList, TabPanel } from "@mui/lab";
import { textAlign } from "@mui/system";
// import CircleChecked from '@material-ui/icons/CheckCircleOutline';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import queryString from "query-string";
import { useHistory, Link } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DatePicker from "@mui/lab/DatePicker";
import BuyDiscountCoupon from "./BuyDiscountCoupon";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";
// import BuyDiscountCoupon from './BuyDiscountCoupon';
import BonusCouponEx from "./BonusCouponEx";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const inputTheme = createTheme({
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-13.5px",
          fontSize: "14px",
        },
        shrink: {
          // top: '-6px'
          display: "none",
        },
        nativeInput: {
          fontSize: "14px",
        },
      },
    },
  },
});

const calTheme = createTheme({
  components: {
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: "90%",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: "30px",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: "-12px",
        },
        shrink: {
          top: 0,
        },
      },
    },
    // MuiCalendarPicker: {
    //   styleOverrides: {
    //     root: {
    //       maxHeight: '300px',
    //       height: '100%',
    //       overflowY: 'hidden',
    //     },
    //     viewTransitionContainer: {
    //       overflowY: 'hidden',
    //     }
    //   },
    // },
    // PrivatePickersSlideTransition: {
    //   styleOverrides: {
    //     root: {
    //       minHeight: '300px',
    //       maxHeight: '300px',
    //       height: '300px',
    //       overflow: 'hidden',
    //     },
    //   },
    // },
    // MuiPickerStaticWrapper: {
    //   styleOverrides: {
    //     root: {
    //       minHeight: '300px',
    //       maxHeight: '300px',
    //       hegiht: '100%'
    //     },
    //   },
    // },
    // MuiPickersDay: {
    //   styleOverrides: {
    //     root: {
    //       '&& .Mui-selected': {
    //         background: '#0092a2',
    //         '&:hover': {
    //           background: '#0092a2'
    //         },
    //       },
    //     },
    //   },
    // },
    // MuiOutlinedInput: {
    //   styleOverrides: {
    //     input: {
    //       height: '18px'
    //     },
    //     root: {
    //       fontSize: ''
    //     }
    //   }
    // }
  },
});

const tabTheme = createTheme({
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          // background: 'pink'
          width: "50%",
          "&&.Mui-selected": {
            background: "#0092a2",
            color: "white",
            width: "50%",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "30px",
          height: "30px",
          width: "90%",
          margin: "0 20px",
        },
        flexContainer: {
          minHeight: "30px",
          height: "30px",
          alignItems: "center",
          justifyContent: "space-between",
        },
        indicator: {
          display: "none",
        },
        scroller: {
          border: "1px solid #e5e5e5",
          borderRadius: "5px",
        },
      },
    },
  },
});

const CustomListItem = (props) => {
  const onBuyClick = props.onBuyClick;
  let {
    pid,
    gubun,
    amount,
    title,
    type,
    term,
    pt_count,
    origin_price,
    discount_rate,
    is_season,
  } = props.item;
  let amount_c = add_comma(amount);
  let amount_o = add_comma(origin_price);
  if (type === "month") type = "개월";
  if (type === "day") type = "일";

  const onAlertTest = () => {
    send_webview_data({
      id: "alert",
      msg: "TEST 메시지",
    });
  };

  return (
    <>
      <ListItem
        onClick={() =>
          onBuyClick({
            pid: pid,
            gubun: gubun,
            amount: amount,
            title: title,
            type: type,
            term: term,
            pt_count: pt_count,
            origin_price: origin_price,
            discount_rate: discount_rate,
            is_season,
          })
        }
        sx={{
          paddingTop: "8px",
        }}
      >
        <ListItemIcon>
          {is_season === "Y" ? (
            <img src={`/img/class_season.png`} height="84px" width="84px" />
          ) : (
            <img
              src={`/img/${gubun.toLowerCase()}_${("00" + pt_count).slice(
                -2,
              )}.jpg`}
              height="84px"
              width="84px"
              onError={(e) => {
                e.target.parentElement.style.display = "none";
              }}
            />
          )}
        </ListItemIcon>
        <ListItemText
          sx={{
            marginLeft: "15px",
          }}
          primary={title}
          secondary={
            <Fragment>
              {/* {"유효기간:" + term + type + ""}
              <br></br> */}
              {discount_rate === 0 ||
              origin_price === 0 ||
              is_season === "Y" ? (
                <Box sx={{ color: "#464646" }}>{amount_c}원</Box>
              ) : (
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {
                      // 할인이 있는 경우만 출력
                      discount_rate > 0 && (
                        <Box
                          sx={{
                            fontSize: "12px",
                            marginTop: "2px",
                            marginRight: 0.5,
                            color: "red",
                          }}
                        >
                          {discount_rate}%할인
                        </Box>
                      )
                    }

                    <Box
                      style={{
                        textDecoration: "line-through",
                        color: "gray",
                        fontSize: "13px",
                        marginTop: "2px",
                      }}
                    >
                      {amount_o}
                    </Box>
                  </Box>
                  <Box sx={{ color: "#464646", marginTop: "-4px" }}>
                    {amount_c}원
                  </Box>
                </Box>
              )}
            </Fragment>
          }
        />
        {/* <Button variant="contained" onClick={onAlertTest}>
          Test
        </Button> */}
        {/* <Button
          variant="contained"
          sx={{
            background: "#de3a7b",
            "&.MuiButton-root:hover": { background: "#de3a7b" },
          }}
          onClick={() =>
            onBuyClick({
              pid: pid,
              gubun: gubun,
              amount: amount,
              title: title,
              type: type,
              term: term,
              pt_count: pt_count,
            })
          }
        >
          구매하기
        </Button> */}
        <IconButton>
          <img
            src="/img/back_button_black.png"
            style={{ transform: "scaleX(-1)" }}
          />
        </IconButton>
      </ListItem>
      <Divider />
    </>
  );
};

const listTheme = createTheme({
  components: {
    MuiListSubheader: {
      styleOverrides: {
        root: {
          lineHeight: "20px",
          color: "black",
          fontWeight: "bold",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          margin: "5px 0 10px 0",
          position: "relative",
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          fontSize: "14px",
          color: "rgba(0, 0, 0, 0.6)",
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          color: "black",
        },
      },
    },
  },
});

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

function BuyLoggedIn(props) {
  // URL에서 탭 바꾸기
  let { tab } = queryString.parse(window.location.search);
  if (tab === undefined) tab = "1";

  const login = props.login;
  const [rows, setRows] = useState([]);
  const [scroll, setScroll] = useState("paper");
  const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [showAgree, setShowAgree] = useState(false);
  const [agree, setAgree] = useState(false);
  const token = localStorage.getItem("token");
  const [couponSeq, setCouponSeq] = useState(0);
  const [showOrder, setShowOrder] = useState(false); // 구매하기 팝업창
  const [pname, setPname] = useState("상품명"); // 결제 상품명
  const [pday, setPday] = useState(0); // 결제 유효기간
  const [pamount, setPamount] = useState(0); // 결제금액
  const [ptcount, setPtcount] = useState(0);
  const [origin_price, setOrigin_price] = useState(0); // 원래금액
  const [discount_rate, setDiscountRate] = useState(0); // 원래금액
  const [pid, setPid] = useState("");
  const [amount, setAmount] = useState(0);
  const [coupon, setCoupon] = useState(0); // 쿠폰코드
  const [gubun, setGubun] = useState(""); // 상품구분
  const [discount, setDiscount] = useState(""); // 결제 시 할인쿠폰
  const [value, setValue] = useState(tab);
  const [type, setType] = useState("");
  const [myCash, setMyCash] = useState(0); // 캐시 : 보유
  const [useCashTf, setUseCashTf] = useState(false);
  const [useCash, setUseCash] = useState(0); // 캐시 : 구매시 사용
  const [couponRows, setCouponRows] = useState([]); //할인쿠폰
  const [couponName, setCouponName] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);
  const [gprice, setGprice] = useState(0); // (전역) 상품가격
  const [gcash, setGcash] = useState(0); // (전역) 내 캐시
  const [total, setTotal] = useState(0); // (전역) 총 결제금액
  const [useCoupon, setUseCoupon] = useState(0); // 쿠폰_할인금액
  const history = useHistory();
  const [convert, setConvert] = useState(false);
  const [remain_coupon, setRemainCoupon] = useState(0); // 남은쿠폰
  const cid = get_cid();
  const center = get_center(cid);
  const [showBonus, setShowBonus] = useState(false); // 보너스쿠폰 설명
  const [isSeason, setIsSeason] = useState(""); // 정기권 Y
  const [usingSeason, setUsingSeason] = useState();

  const openBonus = () => {
    setShowBonus(true);
  };

  const closeBonus = () => {
    setShowBonus(false);
  };

  const handleChange = (event, newValue) => {
    history.push("/buy?tab=" + newValue);
    setValue(newValue);
  };

  const openAgreeClick = (e) => {
    setShowAgree(true);
    history.push("/buy?tab=1");
  };

  const closeAgreeClick = () => {
    setShowAgree(false);
  };

  const onConfirmClick = () => {
    setAgree(true);
    closeAgreeClick();
  };

  const tabChange = (e, newValue) => {
    setValue(newValue);
  };

  const get_product = async () => {
    let result = await axios.post(configState.api + "/gympass/get_product", {
      cid: center.product_cid,
      mcd: login.mcd,
    });
    setUsingSeason(result.data.is_season);
    setRows(result.data.rows);
  };

  // const gohyeonRows = rows.filter((el) => el.pid !== 'PDR10000038' && el.pid !== 'PDR10000040');
  // const jeongguanRows = rows.filter((el) => el.pid !== 'PDR00000086' && el.pid !== 'DOC00000009');

  // 구매하기 submit
  const onSubmit = async () => {
    let result;

    // 시즌권은 이용중인 쿠폰이 있으면 구매불가
    if (isSeason) {
      result = await axios.post(configState.api + "/gympass/ck_season", {
        cid,
        mcd: login.mcd,
      });
      if (result.data.success === 0) {
        Swal.fire("오류", result.data.msg);
        return;
      }
    }

    // 시작일
    if (date === null) {
      Swal.fire("시작 날짜를 선택하세요.");
      return;
    }

    // 약관
    if (!agree) {
      Swal.fire("이용 약관을 읽고 동의 후 구매 가능합니다.");
      return;
    }

    // pr('cid='+configState.cid);
    // pr('date='+date);
    // pr('agree='+agree);
    // pr('pid='+pid);
    // pr('mcd='+login.mcd);
    // pr('amount='+amount);
    // pr('coupon_seq='+coupon);

    // 결제시 필요한 본인 추가정보
    result = await axios.post(configState.api + "/gympass/get_member_one", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    const mb_name = result.data.member.name;
    const merchant_uid = `mid_${new Date().getTime()}`;
    // pr("mb_name=" + mb_name);
    // pr("merchant_uid=" + merchant_uid);

    // 카드결제 시작정보 저장
    result = await axios.post(configState.api + "/gympass/cardpay_start", {
      cid: cid,
      sdate: date,
      merchant_uid: merchant_uid,
      pid: pid,
      mcd: login.mcd,
      sale_price: amount,
      amount: total,
      use_cash: useCash,
      use_coupon: useCoupon,
      coupon_seq: couponSeq,
      request_bonus_coupon: convert ? "Y" : "",
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    }

    // 결제할 금액이 0인 경우 처리 완료처리
    if (gprice > 0 && total === 0) {
      // 웹뷰통신 : 결제완료
      const data = {
        id: "cardpay_result_open",
        merchant_uid: merchant_uid, // 주문번호
        imp_uid: merchant_uid, // 카드결제 없는경우
        success: "true",
        paid_amount: 0, // 카드결제 없는경우
        error_msg: "0원 결제 (무료등록)", // 무료구매
        imp_success: "true",
        buyer_name: "",
        pt_type: gubun,
      };
      send_webview_data(data);
      return;
    }

    // 결제모듈 : onoffkorea
    if (center.payment === "onoffkorea") {
      const data = {
        cid: cid,
        onfftid: center.onfftid,
        merchant_uid: merchant_uid,
        memid: login.mcd,
        amt: total,
        buyer_nm: mb_name,
        user_phone: "",
        product_nm: gubun + " " + pname, // 주문명,
        payUrl: configState.api + "/gympass/payment_start",
        cnclUrl: configState.api + "/gympass/payment_cancel",
        rtnUrl: configState.api + "/gympass/payment_return",
        callUrl: configState.api + "/gympass/payment_call",
        app_scheme: "myawesomeapp", // iphone app_scheme
        id: "onoff_cardpay_window_open",
      };
      // console.table(data);
      send_webview_data(data);
    }

    // 결제모듈 : 아임포트
    if (center.payment === "iamport") {
      const getPortoneData = result.data.portoneData;
      const portoneData = {
        pg: center.pg,
        userCode: center.userCode,
        tierCode: center.tierCode,
      };
      if (getPortoneData.changed_at) {
        portoneData.pg = getPortoneData.pg;
        portoneData.userCode = getPortoneData.user_code;
        portoneData.tierCode = getPortoneData.tier_code;
      }
      const data = {
        pay_method: "card", // 결제수단
        merchant_uid: merchant_uid, // 주문번호
        amount: total, // 결제액
        name: gubun + " " + pname, // 주문명
        buyer_name: mb_name, // 구매자 이름
        buyer_tel: "", // 구매자 전화번호
        buyer_email: "", // 구매자 메일
        buyer_addr: "", // 구매자 주소
        buyer_postcode: "", // 구매자 우편번호
        id: "cardpay_window_open",
        cid: cid,
        pid: pid,
        sdate: date,
        mcd: login.mcd,
        ...portoneData,
      };

      // 결제창 띄우기 (앱)
      send_webview_data(data);
    }
  };

  // 구매하기 & 상세정보 팝업
  const onBuyClick = async (props) => {
    let {
      pid,
      gubun,
      amount,
      title,
      type,
      term,
      pt_count,
      origin_price,
      discount_rate,
      is_season,
    } = props;
    if (usingSeason === "Y")
      return Swal.fire({
        icon: "warning",
        title: "알림",
        text: "정기권 사용중에는 쿠폰을 구매할 수 없습니다.",
      });

    setPname(title);
    setType(type);
    setPday(term);
    setShowOrder(true);
    setPamount(amount);
    setOrigin_price(origin_price);
    setDiscountRate(discount_rate);
    setAgree(false);
    setDate(moment().format("YYYY-MM-DD"));
    setPid(pid);
    setAmount(amount);
    setGubun(gubun);
    setPtcount(pt_count);
    setIsSeason(is_season);

    // 캐시사용 초기화
    setUseCash(0);
    setUseCoupon(0);
    setUseCashTf(false);

    // 전역변수
    setGprice(amount);
    setTotal(amount);
    bonuscoupon_count(gubun);
    setConvert(false);
  };

  const onCalendarChange = (dt) => {
    let dt_format = moment(dt).format("YYYY-MM-DD");
    setDate(dt_format);
  };

  useEffect(() => {
    get_product();
  }, []);

  const load_mycash = async () => {
    let postData = {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/gympass/home_count_cash",
      postData,
    );
    if (result.data.success === 1) {
      setMyCash(result.data.count);
      setGcash(result.data.count); // 전역변수
    }
  };

  // 보너스쿠폰신청 - 남은쿠폰
  const bonuscoupon_count = async (gubun) => {
    let result = await axios.post(
      configState.api + "/gympass/bonuscoupon_count",
      {
        token: token,
        mcd: login.mcd,
        level: login.level,
        cid: cid,
        pt_type: gubun,
      },
    );
    if (result.data.count > 0) {
      setRemainCoupon(result.data.count);
    }
  };

  // 할인쿠폰
  // const load_discount = async () => {
  //   pr("load_data");
  //   let result = await axios.post(configState.api + "/gympass/my_coupon_discount", {
  //     token: token,
  //     cid: configState.cid,
  //     mcd: login.mcd,
  //     level: login.level,
  //   });
  //   setCouponRows(result.data.couponRows);
  // };

  useEffect(() => {
    // load_discount();
    load_mycash();
  }, []);

  // 캐시사용
  useEffect(() => {
    calc_total();
  }, [useCashTf, useCoupon]);

  // 최종금액 계산
  const calc_total = () => {
    let tmp_total = gprice;
    let tmp_mycash = gcash;
    let tmp_usecash = 0;

    if (useCoupon > 0) {
      tmp_total = tmp_total - useCoupon;
    }

    if (useCashTf) {
      if (tmp_mycash > 0) {
        if (tmp_mycash >= tmp_total) {
          // 캐시가 상품금액보다 큰 경우
          tmp_usecash = tmp_total;
          tmp_mycash = tmp_mycash - tmp_usecash;
          tmp_total = 0;
        } else {
          tmp_usecash = tmp_mycash;
          tmp_mycash = tmp_mycash - tmp_usecash;
          tmp_total = tmp_total - tmp_usecash;
        }
      }
    }
    setUseCash(tmp_usecash);
    setMyCash(tmp_mycash);
    setTotal(tmp_total);
  };

  return (
    <Grid container height="100%">
      {/* 약관보기 팝업 */}
      <Dialog open={showAgree} onClose={closeAgreeClick} scroll={scroll}>
        <DialogTitle>카드결제 이용약관</DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogText></DialogText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onConfirmClick}>
            동의
          </Button>
          <Button variant="contained" onClick={closeAgreeClick}>
            취소
          </Button>
        </DialogActions>
      </Dialog>

      {/* 보너스쿠폰설명 팝업 */}
      <Dialog
        open={showBonus}
        fullScreen
        onClose={closeBonus}
        TransitionComponent={Transition}
      >
        <Box>
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeBonus} />
            <Box
              sx={{
                margin: "25px 0 0 10px",
                fontSize: "22px",
              }}
            >
              보너스쿠폰 안내
            </Box>
          </Box>
          <Divider />
          <BonusCouponEx />
        </Box>
      </Dialog>

      {/* 구매하기 팝업 */}
      <Dialog open={showOrder} fullScreen TransitionComponent={Transition}>
        <Box>
          <AppBar sx={{ position: "static", backgroundColor: "#d93c7a" }}>
            <Box
              style={{
                // position: "fixed",
                position: "absolute",
                top: 0,
                width: "100%",
                height: "260px",
                overflow: "hidden",
                zIndex: 10,
              }}
            >
              <img src="/img/buy_header_noword.jpg" style={{ width: "100%" }} />
              <Box
                sx={{
                  position: "absolute",
                  width: "100%",
                  textAlign: "center",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",

                  // fontWeight: 'bold'
                }}
              >
                {gubun === "CLASS" ? (
                  <>
                    <Box
                      sx={{
                        fontSize: "46px",
                        fontFamily: "BebasNeue",
                        color: "white",
                      }}
                    >
                      CLASS COUPON
                    </Box>
                    <Box
                      sx={{
                        fontSize: "18px",
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: "-6px",
                      }}
                    >
                      클래스쿠폰
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        fontSize: "46px",
                        fontFamily: "BebasNeue",
                        color: "white",
                      }}
                    >
                      PASS COUPON
                    </Box>
                    <Box
                      sx={{
                        fontSize: "18px",
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                        marginTop: "-6px",
                      }}
                    >
                      패스쿠폰
                    </Box>
                  </>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                // position: "fixed",
                position: "absolute",
                top: 0,
                zIndex: 20,
              }}
              onClick={() => setShowOrder(false)}
            >
              {/* <Avatar> */}
              <img
                src="/img/back_button.png"
                style={{ height: "30px", margin: "32px 12px" }}
              ></img>
              {/* </Avatar> */}
            </Box>
          </AppBar>
          <Box
          // sx={{ p: 1 }}
          >
            <Box sx={{ height: "270px" }}></Box>
            {/* <Box
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}> */}
            <ThemeProvider theme={tabTheme}>
              <TabContext value={value} variant="fullWidth">
                <TabList onChange={handleChange}>
                  <Tab label="쿠폰 결제" value="1" />
                  <Tab label="쿠폰 이용방법" value="2" />
                </TabList>
                <TabPanel
                  value="1"
                  sx={{
                    width: "100%",
                    padding: 0,
                  }}
                >
                  <div className="flex items-center p-5">
                    <div className="flex-shrink-0">
                      {isSeason === "Y" ? (
                        <img
                          src={`/img/class_season.png`}
                          height="84px"
                          width="84px"
                        />
                      ) : (
                        <img
                          src={`/img/${gubun.toLowerCase()}_${(
                            "00" + ptcount
                          ).slice(-2)}.jpg`}
                          height="84px"
                          width="84px"
                          onError={(e) => {
                            e.target.parentNode.style.display = "none";
                          }}
                        />
                      )}
                    </div>
                    <Box
                      sx={{
                        marginLeft: "10px",
                      }}
                    >
                      <Typography fontSize={20} sx={{ fontWeight: "bold" }}>
                        {pname}
                      </Typography>
                      <Box>
                        {/* <Typography fontSize={13}>
                          판매금액: {add_comma(pamount)}원
                        </Typography> */}

                        {isSeason === "Y" && (
                          <div className="w-full mb-5 text-xs text-red-500 font-bold">
                            <p>구매시 할인쿠폰은 적용되지 않습니다.</p>
                            <p>기간내에만 클래스 예약이 가능합니다.</p>
                            <p>
                              클래스 쿠폰과 같이 보너스 쿠폰으로 이월되지
                              않습니다.
                            </p>
                            <p>환불 시 1일 이용료가 적용됩니다.</p>
                          </div>
                        )}
                      </Box>
                    </Box>
                  </div>
                  <div className="text-center">
                    <p className="text-lg font-semibold text-gray-700">
                      유효기간 : 구매일로 부터 {pday}
                      {type}간
                    </p>
                  </div>

                  {/* 할인쿠폰 사용 */}
                  {isSeason !== "Y" && (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 1,
                      }}
                    >
                      <BuyDiscountCoupon
                        login={login}
                        total={gprice}
                        setUseCoupon={setUseCoupon}
                        setCouponSeq={setCouponSeq}
                      ></BuyDiscountCoupon>

                      <ThemeProvider theme={calTheme}>
                        {/* {couponList.map((item, index)=>{
    alert(couponList)
  })} */}
                        {/* <Select
    value={couponName}
    >
    {couponList.map((item, index) => {
      console.log(item)
      const remain_count =
    item.can_use
const use_amount = item.use_amount;
let is_available = false;
const today = moment().format("YYYY.MM.DD");
const enroll_sdate = item.sdate; // 시작일
const enroll_edate = moment(item.edate).format(
    "YYYY.MM.DD"
);
if (remain_count === "Y") {
  if (enroll_edate > today) {
      if(use_amount <= 0) {
          is_available = true;
      }
  }
}
const regdate = item.regdate;
const cname = item.cname;
return(
  <>
  <MenuItem value={item.name}>{item.name}</MenuItem>
  </>
)
    })}
  </Select> */}
                      </ThemeProvider>
                    </Box>
                  )}

                  {/* 캐시사용 */}
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 0.4,
                    }}
                  >
                    <Box
                      sx={{
                        width: "90%",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        fontSize={14}
                        fontWeight="bold"
                        textAlign="left"
                        marginBottom="5px"
                      >
                        캐시사용 ({add_comma(myCash)}캐시)
                      </Box>
                      <FormControlLabel
                        sx={{
                          margin: "0 0 5px 0",
                          width: "fit-content",
                        }}
                        control={
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Checkbox
                              size="small"
                              checked={useCashTf}
                              onChange={(e) => setUseCashTf(e.target.checked)}
                              sx={{
                                width: 30,
                                padding: "4px",
                              }}
                            />
                            <Box
                              sx={{
                                fontSize: "14px",
                                width: "100%",
                                pr: 1.1,
                              }}
                            >
                              전액사용
                            </Box>
                          </Box>
                        }
                        label=""
                      />
                    </Box>
                    {/* <ThemeProvider theme={calTheme}>
                      <TextField defaultValue={0} size='small' value={useCash} />
                    </ThemeProvider> */}
                  </Box>

                  <Divider
                    sx={{ mt: 0.5 }}
                    width="93%"
                    flexItem
                    variant="middle"
                  />

                  {/* 결제금액 계산 */}
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: "90%",
                        fontWeight: "bold",
                        fontSize: "14px",
                        marginBottom: "5px",
                      }}
                    >
                      결제금액
                    </Box>
                    {discount_rate > 0 ||
                      (isSeason !== "Y" && (
                        <>
                          <Box
                            sx={{
                              width: "90%",
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: "14px",
                            }}
                          >
                            <Box sx={{ pl: 0.5, fontSize: 14, color: "gray" }}>
                              소비자가
                            </Box>
                            <Box sx={{ color: "gray" }}>
                              <span style={{ textDecoration: "line-through" }}>
                                {add_comma(origin_price)}원
                              </span>
                              <span style={{ color: "red" }}>
                                {" "}
                                {discount_rate}%할인
                              </span>
                            </Box>
                          </Box>
                        </>
                      ))}
                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        mt: 0.5,
                      }}
                    >
                      <Box sx={{ pl: 0.5, fontSize: 14 }}>판매금액</Box>
                      <Box>{add_comma(pamount)}원</Box>
                    </Box>

                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        mt: 0.5,
                      }}
                    >
                      <Box sx={{ pl: 0.5, fontSize: 14 }}>쿠폰할인</Box>
                      <Box>
                        {useCoupon > 0 ? "-" : ""}
                        {add_comma(useCoupon)}원
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        mt: 0.5,
                      }}
                    >
                      <Box sx={{ pl: 0.5, fontSize: 14 }}>캐시할인</Box>
                      <Box>
                        {useCash > 0 ? "-" : ""}
                        {add_comma(useCash)}원
                      </Box>
                    </Box>

                    <Divider
                      sx={{ mt: 0.7 }}
                      width="93%"
                      flexItem
                      variant="middle"
                    />
                    <Box
                      sx={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                        fontWeight: "bold",
                        mt: 1,
                      }}
                    >
                      <Box>총 결제금액</Box>
                      <Box>{add_comma(total)}원</Box>
                    </Box>
                  </Box>

                  {remain_coupon > 0 && isSeason !== "Y" ? (
                    <>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          mt: 0.4,
                        }}
                      >
                        <Box
                          sx={{
                            width: "90%",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box
                            fontSize={14}
                            fontWeight="bold"
                            textAlign="left"
                            marginBottom="5px"
                            alignItems="center"
                            display="flex"
                          >
                            보너스쿠폰 신청
                            <HelpOutlineIcon
                              onClick={openBonus}
                              fontSize="14px"
                              sx={{ marginTop: "0", padding: "0 2px" }}
                            />{" "}
                            (남은쿠폰 {add_comma(remain_coupon)}장)
                          </Box>

                          <FormControlLabel
                            control={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "right",
                                }}
                              >
                                <Checkbox
                                  size="small"
                                  checked={convert}
                                  onChange={(e) => setConvert(e.target.checked)}
                                />
                                <Box
                                  sx={{
                                    fontSize: "14px",
                                  }}
                                >
                                  신청
                                </Box>
                              </Box>
                            }
                            label=""
                          />
                        </Box>
                      </Box>
                    </>
                  ) : null}
                  <Box sx={{ height: "150px" }}></Box>

                  <Box
                    sx={{
                      mt: 3,
                      position: "fixed",
                      bottom: 20,
                      left: 0,
                      width: "100%",
                      zIndex: 10,
                      background: "white",
                    }}
                  >
                    <FormControlLabel
                      sx={{
                        width: "100%",
                        justifyContent: "center",
                        margin: 0,
                        margin: "5px 0 10px 0",
                      }}
                      onClick={openAgreeClick}
                      control={
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            width: "90%",
                            height: "30px",
                            border: "1px solid #e5e5e5",
                            borderRadius: "12px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "80%",
                            }}
                          >
                            <Checkbox
                              disabled={true}
                              checked={agree}
                              icon={<RadioButtonUncheckedIcon />}
                              checkedIcon={<CheckCircleIcon />}
                              sx={{
                                width: "20%",
                                "&.Mui-checked": {
                                  color: "#0092a2",
                                },
                              }}
                            />
                            <Typography
                              fontSize={15}
                              color="#9fa0a0"
                              fontWeight="bold"
                            >
                              이용약관 동의 (필수)
                            </Typography>
                          </Box>
                          <img src="/img/back_gray.png" />
                        </Box>
                      }
                      label=""
                    />

                    <Button
                      variant="contained"
                      fullWidth
                      size="large"
                      onClick={onSubmit}
                      sx={{
                        width: "100%",
                        // position: 'fixed',
                        // bottom: 0,
                        // left: 0,
                        padding: "5px 5px",
                        fontSize: "18px",
                        background: "#0092a2",
                        fontWeight: "bold",
                        borderRadius: 0,
                      }}
                    >
                      결제하기
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      position: "fixed",
                      bottom: 0,
                      height: "20px",
                      width: "100%",
                      background: "white",
                    }}
                  ></Box>
                </TabPanel>
                <TabPanel
                  value="2"
                  sx={{
                    width: "100%",
                    padding: 0,
                  }}
                >
                  {isSeason === "Y" ? (
                    <Box
                      sx={{
                        background: "#f1f2f2",
                        margin: "20px",
                        padding: "20px",
                        borderRadius: "5px",
                      }}
                    >
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        정기권 구매 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        1. 쿠폰구매 페이지에서 원하는 정기권을 누릅니다.
                        <br></br>
                        2. 정기권결제 페이지에서 구매하려는 클래스가 맞는지
                        확인합니다.
                        <br></br>
                        3. 정기권은 구매일 부터 사용가능합니다.
                        <br></br>
                        4. 이용약관을 눌러 약관 확인 후 동의 버튼을 누릅니다.
                        <br></br>
                        5. 최하단의 결제하기 버튼을 누릅니다.
                        <br></br>
                        <br></br>
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        정기권 사용 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        구입한 정기권은 내수업 페이지의 내쿠폰 탭에서 확인
                        가능합니다.
                        <br></br>
                        클래스 예약은 정기권 구매 이후 아래 두 가지 방법으로
                        가능합니다.
                        <br></br>
                        <br></br>
                        1. 수업예약 페이지에서 바로 예약
                        <br></br>
                        2. 내수업 ={">"} 내쿠폰 탭에서 정기권 선택 ={">"}{" "}
                        수업예약 페이지로 이동 ={">"} 예약
                        <br></br>
                        <br></br>
                        정기권 유효기간은 구매일로 부터 90일 까지입니다.
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        유효기간이 지난 미사용 쿠폰은 사용 불가 됩니다.
                      </Box>
                      <br></br>
                      <br></br>
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        정기권 예약 취소 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        예약수업 취소는, 내수업 페이지의 내수업 탭에서 예약취소
                        버튼 클릭 시 가능합니다.
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        단, 당일 수업 취소는 불가능합니다. (수업시작 24시간
                        전까지 취소 가능)
                      </Box>
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      예약 후 사용 된(No-Show 쿠폰) 반환 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
                      <br></br>
                      &middot; 불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
                      <br></br>
                      &middot; 반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환
                    </Box> */}
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      구매 쿠폰 양도 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      1. 클래스 쿠폰 양도 수수료만 내면 누구에게나 양도 가능합니다.
                      <br></br>
                      2. 양도 수수료는 쿠폰 종류와 관계없이 2만원으로 책정합니다.
                      <br></br>
                      3. 클래스 쿠폰을 양도받는 분은 꼭 남은 유효기간을 확인하시기 바랍니다.
                      <br></br>
                      4. 양도 절차가 진행된 클래스 쿠폰은 환불신청할 수 없습니다.
                    </Box> */}
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      구매 쿠폰 환불 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      환불 신청은 쿠폰 구매 후 미사용 쿠폰에 한해서만 5일 이내에 가능합니다.
                      <br></br>
                      단, 1회권은 유효기간이 7일이므로 구매 후 3일 이내에만 환불 신청 가능합니다.
                      <br></br>
                      구매 쿠폰을 단 1회라도 사용했을 시, 남은 쿠폰은 환불 불가합니다.
                      <br></br>
                    </Box> */}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        background: "#f1f2f2",
                        margin: "20px",
                        padding: "20px",
                        borderRadius: "5px",
                      }}
                    >
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        쿠폰 구매 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        1. 쿠폰구매 페이지에서 원하는 쿠폰을 누릅니다.
                        <br></br>
                        2. 쿠폰결제 페이지에서 구매하려는 쿠폰이 맞는지
                        확인합니다.
                        <br></br>
                        3. 쿠폰은 구매일 부터 사용가능합니다
                        <br></br>
                        4. 이용약관을 눌러 약관 확인 후 동의 버튼을 누릅니다.
                        <br></br>
                        5. 최하단의 결제하기 버튼을 누릅니다.
                        <br></br>
                        <br></br>
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        쿠폰 사용 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        구입한 쿠폰은 내수업 페이지의 내쿠폰 탭에서 확인
                        가능합니다.
                        <br></br>
                        클래스 예약은 정기권 구매 이후 아래 두 가지 방법으로
                        가능합니다.
                        <br></br>
                        <br></br>
                        1. 수업예약 페이지에서 바로 예약
                        <br></br>
                        2. 내수업 ={">"} 내쿠폰 탭에서 사용을 원하는 쿠폰 선택 =
                        {">"}
                        수업예약 페이지로 이동 ={">"} 예약
                        <br></br>
                        <br></br>
                        쿠폰 유효기간은 쿠폰 구매 시 설정한 날짜부터 시작으로
                        합니다.
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        유효기간이 지난 미사용 쿠폰은 사용 불가 됩니다.
                      </Box>
                      <br></br>
                      <br></br>
                      <Box
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        쿠폰 예약 취소 방법
                      </Box>
                      <br></br>
                      <Box
                        sx={{
                          fontSize: "14px",
                        }}
                      >
                        예약수업 취소는, 내수업 페이지의 내수업 탭에서 예약취소
                        버튼 클릭 시 가능합니다.
                        <br></br>
                      </Box>
                      <Box
                        sx={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        단, 당일 수업 취소는 불가능합니다. (수업시작 24시간
                        전까지 취소 가능)
                      </Box>
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      예약 후 사용 된(No-Show 쿠폰) 반환 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      불가항력적인 사유로 예약한 클래스에 참석하지 못한 경우, 관련 증명서류를 지참하여 쿠폰 반환 신청을 할 수 있습니다.
                      <br></br>
                      &middot; 불가항력 사유 : 천재지변, 사고, 질병, 부고 등이 해당되며 증빙서류 제출이 가능한 사유
                      <br></br>
                      &middot; 반환 절차 : 내수업에서 만료 쿠폰 반환 신청 클릭 => 관련 증빙서류 업로드 => 해당 사유등록확인 절차 후 쿠폰 반환
                    </Box> */}
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      구매 쿠폰 양도 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      1. 클래스 쿠폰 양도 수수료만 내면 누구에게나 양도 가능합니다.
                      <br></br>
                      2. 양도 수수료는 쿠폰 종류와 관계없이 2만원으로 책정합니다.
                      <br></br>
                      3. 클래스 쿠폰을 양도받는 분은 꼭 남은 유효기간을 확인하시기 바랍니다.
                      <br></br>
                      4. 양도 절차가 진행된 클래스 쿠폰은 환불신청할 수 없습니다.
                    </Box> */}
                      {/* <br></br>
                    <br></br>
                    <Box
                      sx={{
                        fontWeight: 'bold'
                      }}>
                      구매 쿠폰 환불 방법
                    </Box>
                    <br></br>
                    <Box
                      sx={{
                        fontSize: '14px'
                      }}>
                      환불 신청은 쿠폰 구매 후 미사용 쿠폰에 한해서만 5일 이내에 가능합니다.
                      <br></br>
                      단, 1회권은 유효기간이 7일이므로 구매 후 3일 이내에만 환불 신청 가능합니다.
                      <br></br>
                      구매 쿠폰을 단 1회라도 사용했을 시, 남은 쿠폰은 환불 불가합니다.
                      <br></br>
                    </Box> */}
                    </Box>
                  )}
                </TabPanel>
              </TabContext>
            </ThemeProvider>
            {/* </Box> */}

            {/* <Box sx={{ mt: 1 }}>
              <Typography fontSize={14}>
                {" "}
                &middot; 쿠폰 시작일을 선택하세요.
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Dialog>
      <Box
        sx={{
          width: "100%",
          height: "50px",
          background: "black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img src={center.logo} height="35px" />
      </Box>
      <Box
        style={{
          // position: "fixed",
          position: "relative",
          top: 0,
          width: "100%",
          height: "260px",
          overflow: "hidden",
          zIndex: 10,
        }}
      >
        <img src="/img/buy_header_noword.png" style={{ width: "100%" }} />
        <ThemeProvider theme={typoTheme}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              // fontWeight: 'bold'
            }}
          >
            <Box
              sx={{
                fontSize: "46px",
                fontFamily: "BebasNeue",
                color: "white",
              }}
            >
              BUY COUPON
            </Box>
            {/* <Box
              sx={{
                fontSize: "18px",
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
                marginTop: "-6px",
              }}
            >
              쿠폰구매
            </Box> */}
          </Box>
        </ThemeProvider>
      </Box>

      <Grid container direction="column" width="100%">
        {center.pass_coupon_sale ? (
          <>
            <ThemeProvider theme={listTheme}>
              {rows.filter((el) => el.gubun === "PASS").length > 0 && (
                <Link
                  to="/buy_description"
                  underline="none"
                  style={{ textDecoration: "none" }}
                >
                  <ListSubheader>
                    패스 쿠폰
                    <HelpOutlineIcon fontSize="small" color="action" />
                  </ListSubheader>
                </Link>
              )}
              {rows.map((item, index) => {
                let { gubun } = item;
                if (gubun === "PASS") {
                  return (
                    <CustomListItem
                      onBuyClick={onBuyClick}
                      key={index}
                      item={item}
                    ></CustomListItem>
                  );
                }
              })}
            </ThemeProvider>
            <Divider width="100%" />
          </>
        ) : null}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        ></Box>

        <List sx={{ zIndex: 0 }}>
          <ThemeProvider theme={listTheme}>
            <Link
              to="/buy_description"
              underline="none"
              style={{ textDecoration: "none" }}
            >
              <ListSubheader>
                클래스 쿠폰
                <HelpOutlineIcon
                  fontSize="small"
                  color="action"
                  style={{ marginLeft: 3 }}
                />
              </ListSubheader>
              {/* <ListItem>클래스 쿠폰은 수업 예약에 필요한 쿠폰입니다.</ListItem> */}
            </Link>
            {rows.map((item, index) => {
              let { gubun } = item;
              if (gubun === "CLASS") {
                return (
                  <CustomListItem
                    onBuyClick={onBuyClick}
                    key={index}
                    item={item}
                  ></CustomListItem>
                );
              }
            })}
          </ThemeProvider>
        </List>
        {/* } */}

        {center.pt_coupon_sale === true && (
          <List sx={{ zIndex: 0 }}>
            <ThemeProvider theme={listTheme}>
              <Link
                to="/buy_description"
                underline="none"
                style={{ textDecoration: "none" }}
              >
                <ListSubheader>
                  PT 쿠폰
                  <HelpOutlineIcon
                    fontSize="small"
                    color="action"
                    style={{ marginLeft: 3 }}
                  />
                </ListSubheader>
              </Link>

              {rows.filter((el) => el.gubun === "PT_MANAGER").length > 0 && (
                <>
                  <Box
                    sx={{
                      paddingLeft: "16px",
                    }}
                  >
                    점장 PT
                  </Box>
                  {rows.map((item, index) => {
                    let { gubun } = item;
                    if (gubun === "PT_MANAGER") {
                      return (
                        <CustomListItem
                          onBuyClick={onBuyClick}
                          key={index}
                          item={item}
                        ></CustomListItem>
                      );
                    }
                  })}
                </>
              )}

              {rows.filter((el) => el.gubun === "PT_TRAINER").length > 0 && (
                <>
                  <Box
                    sx={{
                      paddingLeft: "16px",
                      marginTop: "10px",
                    }}
                  >
                    트레이너 PT
                  </Box>
                  {rows.map((item, index) => {
                    let { gubun } = item;
                    if (gubun === "PT_TRAINER") {
                      return (
                        <CustomListItem
                          onBuyClick={onBuyClick}
                          key={index}
                          item={item}
                        ></CustomListItem>
                      );
                    }
                  })}
                </>
              )}
            </ThemeProvider>
          </List>
        )}

        <Box sx={{ height: "100px" }}></Box>
      </Grid>
      {/* </Grid> */}
      <BottomMenu sx={{ zIndex: 8 }}></BottomMenu>
    </Grid>
  );
}
export default BuyLoggedIn;

// pg: "html5_inicis", // PG사
// const { IMP } = window;
// IMP.init(center.userCode);
// IMP.request_pay(newData, callback);
// 웹뷰를 통해 값을 다 전달한 후에 엡에서 결제창 호출

/*  
    // 웹뷰통신 (앱에서 결제창 실행)
    const data = {
      id: "cardpay_window_open",
      cid: configState.cid,
      pid: pid,
      sdate: date,
      mcd: login.mcd,
      userCode: configState.userCode,
      tierCode: configState.tierCode,
      ...newData,
    };
    send_webview_data(data);
    //   if(window.ReactNativeWebView !== undefined) {
    //   await axios.post(configState.api + '/push/to_mcd', {
    //     cid: configState.cid,
    //     mcd : login.mcd,
    //     title: '쿠폰',
    //     message: `${pname}을 구입했습니다.`
    //   })
    // }
    */
